import { computed, ref } from '@vue/composition-api';
import { getters as creativeGetters, state as creativeState } from './../../store/modules/ads_creative/state';
import store from './../../store/index';
import { useObjectiveHooks } from './../../hooks/creation/objective/objectiveStatus';
export const useState = (): Record<string, any> => {
  const optimizeSucceed = ref(creativeGetters.identityFormData.value.creativeInfo || creativeGetters.identityFormData.value.selectedVideo);
  const curMode = computed(() => creativeGetters.budgetFormData.value.budgetMode);
  const curBudget = computed(() => creativeGetters.budgetFormData.value.budget);
  const startTime = computed(() => creativeGetters.budgetFormData.value.startTime);
  const startTimeDate = computed(() => creativeGetters.budgetFormData.value.startTime?.split(' ')[0]);
  const localStartTimeDate = ref(creativeGetters.budgetFormData.value.startTime?.split(' ')[0]);
  const localStartTimeNonDate = ref(creativeGetters.budgetFormData.value.startTime?.split(' ')[1]);
  const startTimeNonDate = computed(() => creativeGetters.budgetFormData.value.startTime?.split(' ')[1]);
  const endTime = computed(() => creativeGetters.budgetFormData.value.endTime);
  const localEndTimeDate = ref(creativeGetters.budgetFormData.value.endTime?.split(' ')[0]);
  const localEndTimeNonDate = ref(creativeGetters.budgetFormData.value.endTime?.split(' ')[1]);
  const endTimeNonDate = computed(() => creativeGetters.budgetFormData.value.endTime?.split(' ')[1]);
  const budgetFormData = computed(() => creativeGetters.budgetFormData.value);
  const scheduleType = computed(() => creativeGetters.budgetFormData.value.scheduleType);
  const curGoal = computed(() => creativeGetters.budgetFormData.value.curGoal);
  const billingABTest = computed(() => store.state.billingABTest);
  const optimizeFailed = computed(() => creativeGetters.identityFormData.value.failedOptimize);
  const stage = computed(() => creativeState.creative.videoStage.value);
  const accountInfo = computed(() => store.getters['account/accountInfo']);
  const localeTzList = computed(() => store.getters['account/localeTzList']);
  const { isLead, isEngagement, isTraffic, currentObjectiveType } = useObjectiveHooks();
  const newSelf = store.getters['account/newSelf'];
  const canGoSelfQualPage = store.getters['account/canGoSelfQualPage'];
  const ifNeedGoSelfQualification = computed(() => newSelf && canGoSelfQualPage && !billingABTest.value);
  const isSelfAccount = computed(() => store.getters['account/isSelfAccount']);
  const isNotBcChildSelfAccount = computed(() => store.getters['account/isNotBcChildSelfAccount']);
  const isPrepay = computed(() => store.getters['payment/isPrepay']);
  const basicBudget = computed(() => {
    if (isSelfAccount.value) {
      return isTraffic.value ? 5 : 10;
    }
    return 20;
  });
  const ratio = computed(() => accountInfo.value.ratio || 1);
  const minMax = computed(() => basicBudget.value * ratio.value);
  const minBudgetDailyForGoal = computed(() => minMax.value);

  return {
    stage,
    isLead,
    curGoal,
    curMode,
    endTime,
    newSelf,
    isPrepay,
    curBudget,
    startTime,
    isTraffic,
    currentObjectiveType,
    localeTzList,
    accountInfo,
    scheduleType,
    isEngagement,
    isSelfAccount,
    startTimeDate,
    billingABTest,
    endTimeNonDate,
    budgetFormData,
    optimizeFailed,
    optimizeSucceed,
    startTimeNonDate,
    localEndTimeDate,
    canGoSelfQualPage,
    localStartTimeDate,
    localEndTimeNonDate,
    minBudgetDailyForGoal,
    localStartTimeNonDate,
    isNotBcChildSelfAccount,
    ifNeedGoSelfQualification
  };
};
